<div class="d-flex justify-content-center card p-md-5 border-0 p-3">
    <div [id]="cardAnimation"></div>
    <h3 class="title py-1 py-md-2">{{title}}</h3>
    <p class="description">{{description}}</p>
</div>
